<svg viewBox="0 0 22 13" xmlns="http://www.w3.org/2000/svg">
<path d="M1 1L11 11L21 1" stroke-width="2"/>
</svg>
